export default __webpack_public_path__ + "static/media/10_megphone 2.33d6a96d.gif";